import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "../../../components/UI/Table/Table.js"
import { getSectionTemplateList, uploadBulkMasterDataKey, downloadMasterDataKeyTemplate } from './action';
import withAuth from '../../../components/Services/WithAuth';
import './style.css';
import { Col, Card, CardBody, Button, Row } from 'reactstrap';
import { SECTION_TEMPLATE_LIST_TABLE_COLUMNS } from '../constants';
import fileSaver from 'file-saver';
import { toast } from 'react-toastify';
import { Preloading } from '../../../components/UI/Preloader/action.js';
import { DEFAULT_REQUEST_BODY } from './constants';
class ListSectionTemplateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            errorList: [],
            loading: true,
            sorted: {
                id: "createdAt",
                desc: true
            },
            pageSize: 10,
            currentPageIndex: 0
        }
    }
    componentDidMount() {
        this.props.getSectionTemplateList(DEFAULT_REQUEST_BODY);

    }
    componentDidUpdate(prevProps) {
        const { downloadMasterTemplate, downloadMasterTemplateFailure, uploadMasterTemplate, uploadMasterTemplateFailure } = this.props;

        if (downloadMasterTemplate !== prevProps.downloadMasterTemplate) {
            this.props.preloading(false);
            let blob = new Blob([downloadMasterTemplate], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            fileSaver.saveAs(blob, `Section_Template_Master_Data_Key_Create.xlsx`);
        }
        if (downloadMasterTemplateFailure !== prevProps.downloadMasterTemplateFailure) {
            this.props.preloading(false);
            toast.error(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{downloadMasterTemplateFailure.data.message}
                </div>
            );
        }
        if (uploadMasterTemplate !== prevProps.uploadMasterTemplate) {
            this.props.preloading(false);
            toast.success(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{uploadMasterTemplate.message}
                </div>
            );
            document.getElementById('file').value = null
        }
        if (uploadMasterTemplateFailure !== prevProps.uploadMasterTemplateFailure) {
            this.props.preloading(false);
            if (Array.isArray(uploadMasterTemplateFailure.data.message)) {
                this.setState({
                    errorList: uploadMasterTemplateFailure.data.message
                })
            } else {
                toast.error(
                    <div style={{ wordBreak: 'break-all' }}>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{uploadMasterTemplateFailure.data.message}
                    </div>
                );
            }
            document.getElementById('file').value = null
        }
        if (this.props.listData !== prevProps.listData) {
            this.setState({
                // columns: setTableColumns(this.props.listData.data),
                listData: this.props.listData.data,
                loading: false
            })
        }

    }
    handleCancel = () => {
        this.props.history.push('./search');
    }
    downloadMasterDataTemplate = () => {
        this.props.preloading(true);
        this.props.downloadMasterDataKeyTemplate()
    }

    uploadMasterDataTemplate = (event) => {
        this.props.preloading(true);
        this.props.uploadBulkMasterDataKey(event.target.files[0]);
    }
    clearErrors = () => {
        this.setState({
            errorList: []
        })
    }
    onFetchPage = (pageNo, PageSize, sortInfo) => {
        this.props.getSectionTemplateList({
            pageNumber: pageNo,
            pageSize: PageSize,
            sortfield: sortInfo.id,
            sortDirection: (sortInfo.desc) ? 'desc' : 'asc'
        });
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col sm='20'><h4>View All Section Templates</h4></Col>
                    <Col sm='4'><Button outline color='primary' onClick={this.downloadMasterDataTemplate}><i className="fa fa-download"></i></Button>
                        <div color="primary" className="btn btn-primary ml-3 position-relative" title="Upload New Risk Factor">
                            {/* <div> */}
                            <input onChange={this.uploadMasterDataTemplate} type="file" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                            <i className="fa fa-upload"></i>
                        </div>
                    </Col>
                </Row>
                {
                    (this.state.errorList.length > 0) ?
                        <Card className='table-card'>
                            <CardBody>
                                <Card className='table-card text-danger'>
                                    <ul>
                                        {this.state.errorList.map((error, index) => {
                                            return <li key={error}>{index + 1}- &nbsp;{error}</li>
                                        })}
                                    </ul>
                                </Card>
                            </CardBody>
                            <span onClick={this.clearErrors} style={{ marginLeft: '1.6%', cursor: 'pointer' }}>Clear All</span>
                        </Card> : null
                }

                <Card className='table-card'>
                    <CardBody>
                        <Table
                            data={this.state.listData.sectionTemplates}
                            columns={SECTION_TEMPLATE_LIST_TABLE_COLUMNS}
                            minRows={10}
                            defaultPageSize={10}
                            loading={this.state.loading}
                            noDataText="No Section Template Found"
                            multiSort={false}
                            pages={this.state.listData.numberOfPages}
                            showPagination={true}
                            showPaginationTop={false}
                            showPaginationBottom={true}
                            manual  // this would indicate that server side pagination has been enabled 
                            // loading={this.props.loading}
                            onPageChange={(pageIndex) => { // Called when the page index is changed by the user
                                this.setState({
                                    currentPageIndex: pageIndex
                                });
                                this.onFetchPage(pageIndex, this.state.pageSize, this.state.sorted);
                            }}
                            onSortedChange={(newSorted, column, shiftKey) => { // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
                                this.setState({
                                    sorted: newSorted[0]
                                });
                                this.onFetchPage(0, this.state.pageSize, newSorted[0]);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.setState({
                                    pageSize: pageSize
                                })
                                this.onFetchPage(0, pageSize, this.state.sorted);
                            }} />
                    </CardBody>
                </Card>
            </Col>

        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    listData: state.sectionTemplateList.sectionTemplateListData,
    downloadMasterTemplate: state.sectionTemplateList.downloadMasterTemplate,
    downloadMasterTemplateFailure: state.sectionTemplateList.downloadMasterTemplateFailure,
    uploadMasterTemplate: state.sectionTemplateList.uploadMasterTemplate,
    uploadMasterTemplateFailure: state.sectionTemplateList.uploadMasterTemplateFailure
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    getSectionTemplateList: (data) => { dispatch(getSectionTemplateList(data)) },
    downloadMasterDataKeyTemplate: () => { dispatch(downloadMasterDataKeyTemplate()) },
    uploadBulkMasterDataKey: (data) => { dispatch(uploadBulkMasterDataKey(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(ListSectionTemplateComponent));
